import { Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MainApi from "../../../../services/mainApi.service";
import { IIProcesses } from "../../../../models/i-processe";
import { Chip } from "@mui/material";

const I_PROCESSE_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/IProcesse/";
const iProcesseService = new MainApi<IIProcesses>(I_PROCESSE_ROUTE);

const translationPath = "page.4uBus.register.iProcesse.";

const IProcessesPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const columns: GridColDef<IIProcesses>[] = [
    {
      field: "name",
      headerName: t(translationPath + "processe_name") || "Name",
    },
    {
      field: "description",
      headerName: t(translationPath + "description") || "Description",
      renderCell: (params) => {
        if (!params.value) return "-";
        return params.value.name;
      },
    },
    {
      field: "code",
      headerName: t(translationPath + "code") || "Code",
      renderCell: (params) => {
        if (!params.value) return "-";
        return params.value.name;
      },
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 90,
      renderCell: (params) => {
        return (
          <Chip
            size="small"
            label={
              params.value
                ? t(translationPath + "active")
                : t(translationPath + "inactive")
            }
            color={params.value ? "success" : "error"}
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<IIProcesses>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<IIProcesses>
      showDefaultMacroFilters={false}
      service={iProcesseService}
      columns={columns}
      title={t(translationPath + "i_processes")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={t(translationPath + "search")}
      addButtonLabel={t(translationPath + "add_i_processe") || "Add Process"}
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default IProcessesPage;
